import React from 'react';

import cx from '../../utils/classNames';
import toCamelCase from '../../utils/toCamelCase';

import styles from './divider.module.scss';

type Props = {
  /** Custom class to overwrite default styling if needed */
  className?: string;
  /** Controls the variant of the divider */
  variant?: 'default' | 'section' | 'card';
};

export function Divider(props: Props) {
  const { className, variant = 'default' } = props;

  const classNames = cx(styles.divider, styles[toCamelCase('divider', variant)], className);

  return <hr className={classNames} aria-hidden={variant === 'default'} data-testid="divider" />;
}

export default Divider;
